export default {
  search: {
    filter: {
      price: 'Item Price',
    },
    result: {
      empty: 'No records found',
    },
    script: {
      components: {
        price_filter: {
          script: {
            computed: {
              label1: 'All',
              label2: 'Only items with a price greater than 0',
              label3: 'Only items with price 0',
            },
          },
        },
        status_filter: {
          script: {
            computed: {
              label1: 'All',
              label2: 'Only published items',
              label3: 'Only unpublished items',
            },
          },
        },
        /*
          *CatalogItemLoader did not require translation
          *CatalogItemCard did not require translation
        */
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/catalog/search.js